var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_449_4556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.71094 12.3906C5.11964 12.3906 3.59352 11.7585 2.4683 10.6333C1.34308 9.50805 0.710938 7.98192 0.710938 6.39062C0.710938 4.79933 1.34308 3.2732 2.4683 2.14798C3.59352 1.02277 5.11964 0.390625 6.71094 0.390625C8.30224 0.390625 9.82836 1.02277 10.9536 2.14798C12.0788 3.2732 12.7109 4.79933 12.7109 6.39062C12.7109 7.98192 12.0788 9.50805 10.9536 10.6333C9.82836 11.7585 8.30224 12.3906 6.71094 12.3906ZM7.08594 9.47162C7.08594 9.65987 6.91794 9.81213 6.71094 9.81213C6.50394 9.81213 6.33594 9.65987 6.33594 9.47162V5.93463C6.33594 5.74638 6.50394 5.59337 6.71094 5.59337C6.91794 5.59337 7.08594 5.74638 7.08594 5.93463V9.47162ZM6.73419 4.60938C6.57884 4.60938 6.42985 4.54766 6.32 4.43781C6.21015 4.32796 6.14844 4.17898 6.14844 4.02362C6.14844 3.86827 6.21015 3.71929 6.32 3.60944C6.42985 3.49959 6.57884 3.43788 6.73419 3.43788C6.88954 3.43788 7.03853 3.49959 7.14838 3.60944C7.25822 3.71929 7.31994 3.86827 7.31994 4.02362C7.31994 4.17898 7.25822 4.32796 7.14838 4.43781C7.03853 4.54766 6.88954 4.60938 6.73419 4.60938ZM6.71094 11.6406C8.10332 11.6406 9.43868 11.0875 10.4232 10.1029C11.4078 9.11837 11.9609 7.78301 11.9609 6.39062C11.9609 4.99824 11.4078 3.66288 10.4232 2.67831C9.43868 1.69375 8.10332 1.14062 6.71094 1.14062C5.31855 1.14062 3.98319 1.69375 2.99863 2.67831C2.01406 3.66288 1.46094 4.99824 1.46094 6.39062C1.46094 7.78301 2.01406 9.11837 2.99863 10.1029C3.98319 11.0875 5.31855 11.6406 6.71094 11.6406Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_4556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.710938 0.390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.3c2234da4ecea7bfd99fe9305ca53d9e.svg";
export { ForwardRef as ReactComponent };